// EM: Alert models for asset monitoring
export class AssetAlert {
  public objectID!: number;
  public objectName!: string;
  public sensorMeasurementTypeDesignation!: string;
  public sensorName!: string;
  public externalID!: string;
  public colorCode!: string;
}

// TODO: replace
export class AssetAlertNew {
  public objectID!: number;
  public objectName!: string;
  public sensorMeasurementTypeID!: number;
  public sensorMeasurementTypeDesignation!: string;
  public colorCode!: string;
  public objectColorCode!: string;
  public message!: string;
  public timestamp!: Date;
}

export class AlertStatistics {
  public criticalObjects!: number;
  public criticalSensors!: number;
  public alerts!: number;
  public notifications!: number;
}
